import { useCallback } from "react";
import { useOneFrontStore } from "../store/onefront-store";
import { useShallow } from "zustand/react/shallow";

/**
 * Custom hook that provides a state value and a function to update the state value for a specific session key.
 * It is designed to be a drop-in replacement for useState that also persist the value into a form of storage and provided it to the new app during jump url.
 *
 * @param {string} key - The key for the session data.
 * @returns {[any, (value) => void]} - An array containing the current value and a function to update the value.
 */
export const useStateSession = (key) => {
  const { loading, value, setSessionData } = useOneFrontStore(
    useShallow((state) => ({
      loading: state.loading,
      value: state.sessionData[key],
      setSessionData: state.setSessionData
    }))
  );

  const setValue = useCallback(
    (value) => setSessionData(key, value),
    [key, setSessionData]
  );

  return [value, setValue, loading];
};
